
import React from 'react'
import moment from 'moment';

export default function ParcelSummaryComponent({ quoteDetails, leadDetails, getFormattedDate }: any) {

    return (

        <div className="w-full max-w-5xl mx-auto p-6 bg-white shadow-lg rounded-lg border border-gray-200 space-y-6">
            {/* Order Summary Header */}
            <div className="mb-6 text-center">
                <h1 className="text-lg font-semibold text-gray-800 ">Order Summary Details</h1>
            </div>

            {/* Order Summary Table */}
            <table className="w-full text-sm lg:text-base text-gray-700">
                <tfoot>
                    {/* Amount Quoted */}
                    <tr>
                        <td className="p-4 italic text-gray-600">Amount Quoted :</td>
                        <td className="p-4 font-semibold">
                            {quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup[0]?.price?.value}
                        </td>
                    </tr>

                    {/* Relocation Date */}
                    <tr>
                        <td className="p-4 italic text-gray-600">Relocation Date :</td>
                        <td className="p-4 font-semibold">
                            {leadDetails?.quoteData?.date ? getFormattedDate(leadDetails?.quoteData?.date) : moment().format('YYYY-MM-DD h:mm:ss a')}
                        </td>
                    </tr>

                    {/* Service Type */}
                    <tr>
                        <td className="p-4 italic text-gray-600">Service Type :</td>
                        <td className="p-4 font-semibold">Standard</td>
                    </tr>

                    {/* No of Items Added */}
                    <tr>
                        <td className="p-4 italic text-gray-600">No of items added :</td>
                        <td className="p-4 font-semibold">
                            {quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems?.length}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>



    )
}